import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

/* React Confirm Alert */
import { ioteraConfirmAlert } from '../../lib/components/react/react-confirm-alert';

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'
import { actions as modalActions } from '../../redux/ducks/modal'
import { actions as loadingActions } from '../../redux/ducks/loading'

/* Routes */
import { domainIsTenant as dit, AppLink, S } from '../../routes/routes'

/* Object Json */
import { safeDeepGetWithType, safeDeepGet } from 'iotera-base/json';

import './style.scss';

import { SizeMe } from 'react-sizeme';
import IoteraClass from '../../lib/components/react/react-class';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { isNone } from 'iotera-base/object';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const WKEY = 'DASHBOARD_LIST';
const DELETE = 'DELETE';
const RELOAD = 'RELOAD';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

class DashboardCard extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      dropdownOpen: {},
    }
    this.onDelete = this.onDelete.bind(this);
    // this.onOpen = this.onOpen.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  toggle = (e, str) => {
    const _this = this
    setTimeout(() =>
      _this.setState({
        modal: true,
      })
      , 0)
    setTimeout(() =>
      _this.dismissLoading(), 1500);
  }

  dismissLoading() {
    setTimeout(() =>
      this.setState({ modal: false })
      , 1500)
  }

  onDelete = (id) => () => {
    ioteraConfirmAlert(
      null,
      'Apakah anda yakin ingin menghapus dashboard ini?',
      null,
      () => this.props.wSingleRequestCall({
        id: DELETE,
        body: {
          id
        }
      }),
      null,
      null
    )
  }

  onOpen = (path) => {
    const _this = this
    const _props = _this.props
    _this.forceUpdate();
    _props.history.push('.' + S + path)
  }

  onMouseEnter(key, cat) {
    const _this = this
    const _state = _this.state
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    dropdownOpen[key] = true;
    _this.setState({ dropdownOpen });
  }

  onMouseLeave(key) {
    const _this = this
    const _state = _this.state
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown hidden 
    dropdownOpen[key] = false;
    _this.setState({ dropdownOpen });
  }

  gotoDash = path => () => {
    this.props.history.push(`./${path}`)
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    let data = safeDeepGetWithType(_props, ['data'], {});
    let showSkeleton = safeDeepGetWithType(_props['show'], false)
    let dashboardCards = []
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        let mainData = safeDeepGetWithType(data, [key], {});
        let label = safeDeepGetWithType(mainData, ['label'], "Dashboard");
        let id = key;
        let path = safeDeepGetWithType(mainData, ['path'], "./#");
        let parentId = safeDeepGetWithType(mainData, ['parent'], '');
        let parentLabel = '';
        if (parentId !== '') {
          parentLabel = safeDeepGetWithType(data, [parentId, 'path'], '')
        }
        if (parentLabel !== '') {
          parentLabel += '/';
        }
        let dropdownIsOpen = safeDeepGetWithType(_state, ['dropdownOpen', id], false);
        dashboardCards.push(
          <div key={id} className="io-card card__shadow-sm io-card__direct mb-4" onClick={_this.gotoDash(path)}>
            <div className="io-card-body card-body__compact">
              <div className="io-row align-items-center">
                <div className="io-col">
                  <h6>{label}</h6>
                  <h5 className="font-weight-normal text-gray-300 mb-0">
                    ./{parentLabel}<span className='io-text-primary'>{path}</span>
                  </h5>
                </div>
                <div className="io-col-auto" onMouseLeave={(e) => _this.onMouseLeave(id)} >
                  <UncontrolledDropdown isOpen={dropdownIsOpen}>
                    <DropdownToggle style={{ padding: 0, backgroundColor: 'transparent' }} >
                      <div tag="div" className="io-btn btn-sm btn-control" role="button" data-toggle="popover"
                        onMouseOver={(e) => _this.onMouseEnter(id)} style={{ cursor: 'pointer', padding: 4 }}>
                        <span className="material-icons">more_horiz</span>
                      </div>
                    </DropdownToggle>
                    <DropdownMenu style={{ padding: 0, margin: 0 }}>
                      <DropdownItem style={{ margin: 0 }} onClick={_this.gotoDash('_dashboard_conf_/' + path)}  >
                        Edit
                      </DropdownItem>
                      <DropdownItem style={{ margin: 0 }} onClick={_this.onDelete(id)}  >
                        Hapus
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>
            </div>
          </div>
        )
      }
    }
    return (
      <div className="io-container mt-12">
        <div className="io-row align-items-center mb-4">
          <div className="io-col">
            <h3 className="mt-4 font-weight-normal">List of Dashboard</h3>
            <h6 className="text-gray-300 font-weight-normal">Manage dashboard</h6>
          </div>
          <div className="io-col-auto">
            <AppLink {..._props} to={'_dashboard_add_'}  >
              <div className="io-btn io-btn-primary">
                Create Dashboard
              </div>
            </AppLink>
          </div>
        </div>
        {showSkeleton ?
          <div >
            <Skeleton variant="rect" width={'100%'} height={67} />
          </div>
          :
          dashboardCards
        }
      </div>
    )
  }
}

class Dashboards extends IoteraClass {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      navs: {}
    }
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: "/service/web/application/nav/list" },
        wcallback: {
          started: function (id) {
            // TODO Loading
            _props.showLoading();
            _this.setState({
              loading: true
            })
          },
          finished: function (id, result) {
            // TODO Loading
            _props.hideLoading();
            let navs = safeDeepGetWithType(result, ['body', 'navs'], {})
            _this.setState({
              loading: false,
              navs
            })
          }
        }
      }
    );

    _props.wSetConfig({
      single_config: {
        [DELETE]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/nav/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false
                  })
                  _props.showSingleNotification({ message: 'Hapus Dashboard Sukses', level: 'success' });
                  _props.wSingleRequestCall({
                    id: RELOAD,
                  })
                  return;
                }
              }
              _props.showSingleNotification({ message: 'Hapus Dashboard Gagal', position: 'tr', level: 'error' });
            }
          }
        },
        [RELOAD]: {
          wparam: { ...domainIsTenant, path: "/service/web/application/nav/list" },
          wcallback: {
            started: function (id) {
              // TODO Loading
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              // TODO Loadingif (result.code === Result.HTTP.OK) {
              const items = safeDeepGet(_props, ['items'])
              const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
              if (responseResult === Result.SUCCESS) {
                _this.setState({
                  loading: false,
                  navs: safeDeepGetWithType(result, ['body', 'navs'], items)
                })
                return;
              }
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { loading, navs } = _state;
    return (
      <div>
        <SizeMe>{({ size }) =>
          <DashboardCard {..._props} data={navs} displaySize={size} show={loading} />
        }
        </SizeMe>
      </div>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    items: wSelector.getSoleInitMappedRPayload(state, 'navs')
  }
};

const mapDispatchToProps = (dispatch) => ({
  ...wBoundActions(dispatch),
  ...bindActionCreators(notificationActions, dispatch),
  ...bindActionCreators(modalActions, dispatch),
  ...bindActionCreators(loadingActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboards);